import { Box, Button, Dialog, Flex, Text } from '@radix-ui/themes';
import { CompanySlide } from 'admin/types';
import { observer } from 'mobx-react-lite';
import { ErrorOutlineIcon } from 'shared/icons';
import { useSliderManager } from '../slider-manager.provider';
import { toast } from 'sonner';

const DeactivatedDialogView = ({
   slide,
   onClose,
}: {
   slide: CompanySlide;
   onClose: () => void;
}) => {
   const sliderManager = useSliderManager();
   return (
      <Box className="deactivated-dialog">
         <Flex justify="center">
            <Text color="red">
               <ErrorOutlineIcon width={80} height={80} />
            </Text>
         </Flex>

         <Flex justify="center" direction="column" align="center" mt="5" mb="6">
            <Dialog.Title aria-describedby={undefined}>
               <Text>Deactivate Slider?</Text>
            </Dialog.Title>
            <Text> Do you want to Deactivate this Slider?</Text>
         </Flex>

         <Flex justify="center" gap="3">
            <Button
               color="red"
               size="3"
               loading={sliderManager.deactivateSliderState.status === 'pending'}
               onClick={() =>
                  sliderManager.deactivateSlider({
                     dto: {
                        slug: slide.slug,
                     },
                     onSuccess: (resp) => {
                        if (resp.status === 200) {
                           toast.success('Slide deactivated!');
                           sliderManager.loadSlider();
                           onClose();
                        }
                     },
                     onError: () => {
                        toast.success('Something went wrong!');
                     },
                  })
               }
            >
               Confirm
            </Button>

            <Dialog.Close>
               <Button color="gray" size="3">
                  Cancel
               </Button>
            </Dialog.Close>
         </Flex>
      </Box>
   );
};

export const DeactivatedDialog = observer(DeactivatedDialogView);
